<template>
  <div :id="`onedheatmap-${_uid}`" class="onedheatmap" :layout="responsive">
    <visualization-controls
      v-if="visualization"
      :visualization="visualization"
      :show-color="true"
      :show-sort-x="true"
      :show-sort-z="query.zlayers.length > 0"
      :show-recency="true"
      :show-size="true"
    ></visualization-controls>

    <div id="svgDiv">
      <svg></svg>
      <div id="load-div-onedheatmap" class="loading-visualization">
        <div class="d-flex justify-content-center">
          <b-spinner
            style="width: 5rem; height: 5rem; margin-top:20%"
            variant="secondary-orange"
            label="Large Spinner"
            type="grow"
          ></b-spinner>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import VisualizationControls from "@/components/Explore/Visualizations/VisualizationControls";
import GeneralChart from "./GeneralChart";

export default {
  name: "OneDHeatmapView",
  components: {
    VisualizationControls
  },
  props: {
    analyse: {
      required: true,
      type: Object
    },
    responsive: {
      required: true,
      type: Boolean
    }
  },
  data() {
    return {
      query: null,
      visualization: null
    };
  },
  computed: {
    ...mapState({
      filterFocused: state => state.filter.filterFocused,
      subsetFilter: state => state.filter.subsetFilter
    }),
    focused(){
      return this.filterFocused;
    }
  },
  watch: {
    focused(){
      if (this.subsetFilter.length > 0) {
        let subset = this.subsetFilter;
        if (this.subsetFilter.length > 0) {
          subset.splice(-2);
        }
        this.query.subset_filters = [
          subset,
          "AND",
          this.filterFocused.rawquery
        ];
      } else {
        this.query.subset_filters = this.filterFocused
          ? [this.filterFocused.rawquery]
          : [];
      }
      this.visualization.setQuery(this.query);
      this.visualization.draw(true);
    },
    subsetFilter(val){
      if(this.$route.name === "ExploreAnalysisView"){
        this.saveFilterQuery({ query: val });
      }
    },
    analyse(){
      this.initAnalysis();
    }
  },
  mounted() {
    this.initAnalysis();
  },
  methods: {
    ...mapActions(["saveFilterQuery"]),
    initAnalysis(){
      this.query = { ...this.analyse.config.query };
      this.query.subset_filters = this.filterFocused
        ? [this.filterFocused.rawquery]
        : [];

      this.visualization = new GeneralChart(
        `#onedheatmap-${this._uid} svg`,
        "onedheatmap"
      );
      this.visualization.setQuery(this.query);
      this.visualization.draw(true);
    }
  },
  destroyed() {
    this.visualization.destroy();
  }
};
</script>
